import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkConfig } from "@src/store/createAsyncThunk";
import { getAnalyticsProducts } from "@src/store/slices/analyticsProducts";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const openAnalyticsProductPicker = createAsyncThunk<
  void,
  void,
  ThunkConfig
>("productPicker/openAnalyticsProductPicker", (_, { getState, dispatch }) => {
  dispatch(openProductPicker({ type: "analytics" }));

  const analyticsProducts = getAnalyticsProducts(getState());

  // Let's maintain order
  const selectedProducts: ProductPickerSelectedProduct[] = [];
  const lookup: Record<string, true> = {};
  for (const product of analyticsProducts) {
    if (lookup[product.id]) continue;

    const selectedProduct: ProductPickerSelectedProduct = {
      id: product.id,
      title: product.title ?? "",
      image: product.image ?? undefined,
      handle: "",
      requiresSellingPlan: undefined,
    };
    selectedProducts.push(selectedProduct);
    lookup[product.id] = true;
  }
  dispatch(setProductPickerSelectedProducts(selectedProducts));
});
